export default {
  backgroundColor: 'rgba(47,69,84,0)',
  dataBackgroundColor: 'rgba(47,69,84,0.3)',
  fillerColor: 'rgba(167,183,204,0.4)',
  handleColor: '#a7b7cc',
  handleSize: '100%',
  textStyle: {
    color: '#333'
  }
};